import React from 'react';
import './styles.css';
import LandingPage from './LandingPage';

const App = () => {
  return <LandingPage />;
};

export default App;
